<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <p v-if="question.Mandatory" v-html="question.QuestionText+'<font color=red> *</font>'"></p>
        <p v-else v-html="question.QuestionText"></p>
      </v-flex>
      <v-flex xs12 sm6>
        <v-select :rules="[(v) => !this.question.Mandatory || (v != null && v.value != null) || this.$t('Field is required')]"
          return-object
          required
          :label="this.$t('Select')"
          v-model="questionAnswer"
          :items="options"
          filled></v-select>
      </v-flex>
    </v-layout>
    <p v-if="question.QuestionAction == 'Deduction'">
    <v-layout row wrap>
      <v-flex xs12 sm6>
      </v-flex>
      <v-flex xs12 sm3>
        <v-text-field
        return-object
        :rules="[question.Mandatory ? rules.required : true, v => !v || /^[0-9]+$/.test(v) || this.$t('Enter a numeric value')]"
          v-model="questionAnswerAmount"
          :label="this.$t('Amount')+ ' (kg)'"
          filled>
        </v-text-field>
      </v-flex>
      <v-flex xs12 sm3>
        <v-select
          return-object
          v-model="questionAnswerUnit"
          :label="this.$t('Unit')"
          :items="['kg', '%']"
          filled>
        </v-select>
      </v-flex>
    </v-layout>
  </p>
  </v-flex>
</template>

<script>
import rules from '@/core/mixins/common-rules'

export default {
  mixins: [rules],
  props: ['question'],
  data () {
    return {
      selection: null,
      options: [],
      unit: 'kg',
      amount: 0
    }
  },
  computed: {
    questionAnswerUnit: {
      get: function () {
        return this.unit
      },
      set: function (newValue) {
        this.unit = newValue
        if (newValue != null) {
          var res = this.setTextAtIndexInStr(newValue, 2, this.question.AnswerNo)
          this.question.AnswerNo = res
          console.log('res:', res, '  this.question.AnswerNo:', this.question.AnswerNo)
        }
      }
    },
    questionAnswerAmount: {
      get: function () {
        return this.amount
      },
      set: function (newValue) {
        this.amount = newValue
        if (newValue != null) {
          var res = this.setTextAtIndexInStr(newValue, 1, this.question.AnswerNo)
          this.question.AnswerNo = res
          console.log('res:', res, '  this.question.AnswerNo:', this.question.AnswerNo)
        }
      }
    },
    questionAnswer: {
      get: function () {
        return this.selection
      },
      set: function (newValue) {
        this.selection = newValue
        if (newValue != null) {
          // if 'Deduction' we store data in AnswerText liek this "articleno|amount|unit"
          if (this.question.QuestionAction === 'Deduction') {
            var res = this.setTextAtIndexInStr(this.selection.value, 0, this.question.AnswerNo)
            this.question.AnswerNo = res
            this.question.AnswerText = this.selection.text
          } else {
            if (newValue != null) {
              this.question.AnswerNo = this.selection.value
              this.question.AnswerText = this.selection.text
            }
          }
        }
      }
    }
  },
  methods: {
    setTextAtIndexInStr (text, index, str) {
      if (!str || str.split('|').length !== 3) str = '|0|kg' // let ensure that str has a format liek this "x|y|x"
      const namesArray = str.split('|')
      if (index >= 0 && index < namesArray.length) {
        namesArray[index] = text
      } else {
        console.error('Index ' + index + ' out of bounds')
      }
      var res = namesArray.join('|')
      console.log('str:', str, ' res:', res)
      return res
    }
  },
  mounted () {
    // Build option from data in QuestionData
    const options = JSON.parse(this.question.QuestionData.replace(/'/g, '"'))
    this.options = options.map((option) => {
      return {
        value: Object.keys(option)[0],
        text: Object.values(option)[0]
      }
    })

    // Update selection from data in QuestionData (if data exist)
    if (this.question != null && this.question.AnswerNo != null) {
      this.selection = {
        value: this.question.AnswerNo,
        text: this.question.AnswerText
      }
    }
  }
}
</script>

<style>

</style>
